import { getVideoList } from '@/api/baidu'

export default {
    components: {
    },
    model: {
        prop: 'materials',
        event: 'change'
    },
    props: {
        advertiser_id: {
            type: Number,
            default: () => null
        },
        materials:{
            type: Array,
            default: () => []
        },
        num: {
            type: Number,
            default: () => 1
        },
    },
    data () {
        return {
            advertiser_name: '',
            showVideoPage: false,
            data: [],
            pagination: {
                defaultPageSize: 20,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            loading: false,
            columns: [
                { width: 100, title: '视频ID', dataIndex: 'videoid', ellipsis: true },
                { width: 200,title: '视频', scopedSlots: { customRender: 'video' } },
                { width: 300,title: '视频信息', scopedSlots: { customRender: 'name' } },
                { width: 200, title: '添加时间', dataIndex: 'addTime', ellipsis: true },
                { width: 200, title: '修改时间', dataIndex: 'modTime', ellipsis: true },
                { width: 150,title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' }}
            ],
            model: {},
            queryParam: {},
            tableHeight: 0,
            playUrl: null,
            material: null,
            selectMaterials: [],
            selectedRowKeys: [],
            addMaterials: [],
        }
    },
    computed: {},
    watch: {
      
    },
    mounted () {
        this.selectMaterials = this.materials
    },
    methods: {
        buttonClick() {
           
            let videoIds = this.selectMaterials.map(item => item.videoid);
            this.selectedRowKeys = videoIds
            // console.log('当前选中的，', this.selectMaterials, videoIds)

            this.getList()
            this.showVideoPage = true
        },
        choiceMaterialSingle (material) { 
            if (this.selectMaterials.find(function(item) {return item.url === material.url})) {
                return this.$message.error('请勿重复选择')
            }
            this.selectMaterials.push(material)
            this.syncMaterial()
            this.close()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.addMaterials = selectedRows
        },
        choiceMaterialBatch () { 
            // console.log(this.selectMaterials, this.addMaterials)
           let mergedArray = [...new Set([...this.selectMaterials, ...this.addMaterials])];
           let uniqueMaterials = Array.from(mergedArray.reduce((map, obj) => {
            if (!map.has(obj.videoid)) {
              map.set(obj.videoid, obj);
            }
            return map;
          }, new Map()).values());

           //已选个数，可选个数
           let num = uniqueMaterials.length - this.num
            if (num>0) {
                return this.$message.error('当前可选'+ this.num + '个视频，已超出'+num+'个')
            }
        
              
           this.selectMaterials = uniqueMaterials
           this.syncMaterial()
           this.close()
        },
        clearSelectMaterials () {
            this.selectMaterials = []
            this.syncMaterial()
        },
        deleteMaterial(item) {
            if (item.url) {
                this.selectMaterials = this.selectMaterials.filter((material) => material.url !== item.url);
            } else {
                this.selectMaterials = []
            }
            this.syncMaterial()
        },
        syncMaterial () {
            //同步父组件
            this.$emit('change', this.selectMaterials)
            // this.$emit('update:materials', this.selectMaterials)
        },
        close() {
            this.showVideoPage = false
        },
        pageSizeChange(val, pageSize) {
            this.loading = true
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = 1
        },
        handleTableChange(pagination) {
            const pager = {...this.pagination}
            pager.current = pagination.current
            this.pagination = pager
            this.getList()
        },
        getList() {
            this.loading = true
            const pagination = {...this.pagination}

            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize,
                advertiser_id: this.advertiser_id
            })
            if (json.date && json.date.length > 0) {
                json.started_at = json.date[0].format('YYYY-MM-DD')
                json.finished_at = json.date[1].format('YYYY-MM-DD')
                delete json.date
            }

            
            getVideoList(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getList()
        },
        search() {
            this.pagination.current = 1
            this.getList()
        },
        resetSearch() {
            this.queryParam = {}
            this.getList()
        },
        accessTo(route) {
            return this.$helper.accessTo('BaiduController', route)
        },
        imgError(e) {
            let img = e.srcElement
            img.src = this.defaultCover
            img.onerror = null
        },
        showPreviewBox(material) {
            this.preview(material)
        },
        hidePreviewBox() {
            this.material = null
        },
        preview(record, download) {
            this.material = record
            this.playUrl = record.url
            if (download) {
                return window.open(this.playUrl)
            }
        },
        closePreview() {
            this.playUrl = null
            this.$refs.video.pause()
        },
           
    }
}